// src/components/shared/MotusSpinner.js
//
// Animated loading spinner based on the motus logo arc.
// Uses the same gradient and arc shape — spins smoothly.

import React from 'react';

/**
 * @param {object} props
 * @param {number} [props.size=24] — width/height in px
 * @param {string} [props.color] — override stroke color (defaults to motus blue)
 * @param {string} [props.label] — optional text shown below spinner
 * @param {'inline'|'block'} [props.display='inline'] — layout mode
 */
function MotusSpinner({ size = 24, color, label, display = 'inline' }) {
  const gradId = `motus-spin-${Math.random().toString(36).slice(2, 6)}`;
  const strokeColor = color || '#2563EB';

  const spinner = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      style={{ animation: 'motus-spin 1s ease-in-out infinite', display: 'inline-block', flexShrink: 0 }}
    >
      <defs>
        <linearGradient id={gradId} x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor={strokeColor} stopOpacity="0.15" />
          <stop offset="100%" stopColor={strokeColor} />
        </linearGradient>
      </defs>
      {/* Arc inspired by motus logo peak shape */}
      <path
        d="M 6 34 Q 10 10 20 6 Q 30 2 34 14"
        stroke={`url(#${gradId})`}
        strokeWidth="4"
        fill="none"
        strokeLinecap="round"
      />
      {/* Peak dot */}
      <circle cx="34" cy="14" r="3" fill={strokeColor} />
    </svg>
  );

  if (display === 'block' || label) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
        {spinner}
        {label && <span style={{ fontSize: 13, fontWeight: 500, color: '#6B6B63', fontFamily: "'DM Sans',sans-serif" }}>{label}</span>}
        <style>{`@keyframes motus-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <>
      {spinner}
      <style>{`@keyframes motus-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
    </>
  );
}

export default MotusSpinner;
